/**
 * Link to a Solidity source file in the project's GitHub repo. Falls back to
 * plain monospace text when `VITE_REPO_URL` is not set, so the SPA still works
 * when the repo is private or the deployer hasn't configured a public URL.
 */

const REPO_URL = (import.meta.env.VITE_REPO_URL as string | undefined)?.replace(/\/$/, "");

export function ContractSourceLink({ name }: { name: string }) {
  const label = `${name}.sol`;
  if (!REPO_URL) {
    return <code className="font-mono text-foreground/80">{label}</code>;
  }
  return (
    <a
      href={`${REPO_URL}/blob/main/contracts/contracts/${name}.sol`}
      target="_blank"
      rel="noopener noreferrer"
      onClick={(e) => e.stopPropagation()}
      className="font-mono text-foreground/80 underline-offset-2 hover:underline"
    >
      {label}
    </a>
  );
}
